"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "LinkIcon", {
    enumerable: true,
    get: function() {
        return LinkIcon;
    }
});
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var LinkIcon = {
    baseStyle: function(props) {
        var linkDisplayStyles = props.isInline ? {
            display: "inline",
            marginInline: "0.25rem"
        } : {
            display: "inline-flex"
        };
        return _object_spread({}, props.theme.components.Link.baseStyle, linkDisplayStyles);
    },
    variants: {
        "link-primary": function(props) {
            return props.theme.components.Link.variants["link-primary"];
        },
        "link-accent": function(props) {
            return props.theme.components.Link.variants["link-accent"];
        },
        "link-secondary": function(props) {
            return props.theme.components.Link.variants["link-secondary"];
        },
        "link-destroy": function(props) {
            return props.theme.components.Link.variants["link-destroy"];
        }
    },
    defaultProps: {
        size: "l",
        variant: "link-primary"
    }
};
